import React from "react";
import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  Title,
  Button,
} from "./style";
import { toast } from "react-toastify";

const EmailVerificationModal = ({ email, isOpen, onClose }) => {
  const handleOpenYopmail = async () => {
        try {
          const token = JSON.parse(localStorage.getItem("authToken"));
          const response = await fetch(
            "https://admin.whatsappbackupviewer.com/api/email/resend",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    
          if (response.ok) {
            toast.success("Verification email resent successfully!");
            onClose();
          } else {
            const responseData = await response.json();
            toast.error(responseData.message || "Failed to resend email");
          }
        } catch (error) {
          console.error("Error during resend email:", error);
          toast.error("Failed to resend email");
        }
  };

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      <ModalContent style={{ maxWidth: "30% !important" }}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>Please verify your email!</Title>
        <p>
          Your email registration was successful, but email verification is not
          complete. Check your email! If you haven't received the email, click
          the button below to resend the email
        </p>
        <Button onClick={handleOpenYopmail} style={{ marginTop: "20px" }}>
          Resend Verification Email
        </Button>
      </ModalContent>
    </>
  );
};

export default EmailVerificationModal;
